import { render } from "./TermAndConditions.vue?vue&type=template&id=47101192&scoped=true"
import script from "./TermAndConditions.vue?vue&type=script&lang=js"
export * from "./TermAndConditions.vue?vue&type=script&lang=js"

import "./TermAndConditions.vue?vue&type=style&index=0&id=47101192&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47101192"]])

export default __exports__